import { FC } from 'react';

import styles from './PsychicFeaturePallet.module.scss';

import type { IPsychicFeaturePallet } from '../config/declarations';

export const PsychicFeaturePallet: FC<IPsychicFeaturePallet> = ({
  feature,
}) => {
  const trimmedFeature = feature.trim();
  const parts = trimmedFeature.split(' ');
  const ampersand = parts.find((part) => part === '&');
  const firstPart = trimmedFeature.split(' ')[0];

  if (ampersand && firstPart) {
    return (
      <span className={styles.featurePallet}>
        {firstPart}
      </span>
    );
  }

  if (!trimmedFeature.length || ampersand) {
    return null;
  }

  return (
    <span className={styles.featurePallet}>
      {trimmedFeature}
    </span>
  );
};
